export const CARD_TYPES = {
  DELIVERY: 'DELIVERY',
  VISITOR: 'VISITOR',
  BUILDING_DIRECTORY: 'BUILDING_DIRECTORY',
};

export const VISITOR_TYPES = {
  DELIVERY: 'DELIVERY',
  AUTHORIZED: 'AUTHORIZED',
};

export const MODAL_TYPES = {
  CREATE_DELIVERY: 'CREATE_DELIVERY',
  CREATE_GENERAL_VISITOR: 'CREATE_GENERAL_VISITOR',
  CREATE_AUTHORIZED_VISITOR: 'CREATE_AUTHORIZED_VISITOR',
  REJECT_VISITOR: 'REJECT_VISITOR',
};

export const REJECT_VISITOR = 'REJECT_VISITOR';
export const GIVE_ACCESS = 'GIVE_ACCESS';
export const OPEN_VENDOR = 'OPEN_VENDOR';
